import { OPTION_VALUES } from "@ipru-common/constants/InputValues";
import { Buffer } from "buffer";
const Blowfish = require("egoroof-blowfish");

const bfInst = () => new Blowfish(process.env.REACT_APP_DECRYPT_KEY);

const d = (string) => {
  const bf = bfInst();
  const base64Decoded = Buffer.from(string, "base64");
  const decoded = bf.decode(base64Decoded);
  return decoded;
};

// const e = (string) => {
//   const bf = bfInst();
//   // Encode string
//   const encoded = bf.encode(string);
//   const hex = Buffer.from(encoded).toString("base64");
//   return hex;
// };

export const getEnvironment = () => {
  const { DEVELOPMENT, PRODUCTION } = OPTION_VALUES;
  let environment = PRODUCTION;

  if (typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    const api = params.get("api") || "prod";
    environment = api === "dev" ? DEVELOPMENT : PRODUCTION;
  }
  return environment;
};

function ENV() {
  let environment = getEnvironment();
  const { PRODUCTION } = OPTION_VALUES;

  if (environment === PRODUCTION) {
    return {
      REACT_APP_CF: process.env.REACT_APP_CF, // REACT_APP_CONFIG_FILE
      REACT_APP_NMABP: process.env.REACT_APP_NMABP, // REACT_APP_NON_MIDDLEWARE_API_BASE_PP
      REACT_APP_BD: process.env.REACT_APP_BD, //REACT_APP_BASE_DEX
      REACT_APP_APB: process.env.REACT_APP_APB, // REACT_APP_API_PROD_BASE
      REACT_APP_JBK: d(process.env.REACT_APP_JBK), // REACT_APP_JWT_BASIC_KEY
      REACT_APP_JNMBK: d(process.env.REACT_APP_JNMBK), // REACT_APP_JWT_NON_MIDDLEWARE_BASIC_KEY
      REACT_APP_XAK: d(process.env.REACT_APP_XAK), // REACT_APP_X_API_KEY
      REACT_APP_ATHXAK: d(process.env.REACT_APP_ATHXAK), // REACT_APP_AUTH_TOKEN_HEADER_X_API_KEY
      REACT_APP_ATAAK: d(process.env.REACT_APP_ATAAK), // REACT_APP_AUTH_TOKEN_API_AUTH_KEY
      REACT_APP_BA: process.env.REACT_APP_BA, // REACT_APP_BUY_API
      REACT_APP_KB: process.env.REACT_APP_KB, // REACT_APP_KEY_BUYUAT
      REACT_APP_CSP: d(process.env.REACT_APP_CSP), // REACT_APP_CUSTOMER_SUPPORT_PASSKEY_DEV
      REACT_APP_TDQ: d(process.env.REACT_APP_TD), // reate key for tata journey to decrypt
    };
  }
  return {
    REACT_APP_CF: process.env.REACT_APP_CF_DEV,
    REACT_APP_NMABP: process.env.REACT_APP_NMABP_DEV,
    REACT_APP_BD: process.env.REACT_APP_BD_DEV,
    REACT_APP_APB: process.env.REACT_APP_APB_DEV,
    REACT_APP_JBK: d(process.env.REACT_APP_JBK_DEV),
    REACT_APP_JNMBK: d(process.env.REACT_APP_JNMBK_DEV),
    REACT_APP_XAK: d(process.env.REACT_APP_XAK_DEV),
    REACT_APP_ATHXAK: d(process.env.REACT_APP_ATHXAK_DEV),
    REACT_APP_ATAAK: d(process.env.REACT_APP_ATAAK_DEV),
    REACT_APP_BA: process.env.REACT_APP_BA_DEV,
    REACT_APP_KB: process.env.REACT_APP_KB_DEV,
    REACT_APP_CSP: d(process.env.REACT_APP_CSP_DEV),
    REACT_APP_TDQ: d(process.env.REACT_APP_TD), // reate key for tata journey to decrypt
  };
}

export default ENV;
